import { RouteConfig } from "vue-router";
import { Network } from "@/network";
import { DefaultPath } from "@/constant/GroupPermission";

const AnnouncementRoute: Array<RouteConfig> = [
  {
    path: "/announcement/list",
    component: () => import("@/views/ap/announcement/List.vue"),
    beforeEnter: (to, from, next) => {
      if (Network.authCheck()) next();
      else next("/login");
    }
  },
  {
    path: "/announcement/cont",
    component: () => import("@/views/ap/announcement/Cont.vue"),
    beforeEnter: (to, from, next) => {
      if (Network.authCheck()) next();
      else next("/login");
    }
  },
];

export { AnnouncementRoute };
